// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2jkEU","options":"AnswerScale_options__1P6Q6","selected":"AnswerScale_selected__U5RvZ"};